import { apiUtils } from '../api-utils';

import { UnderwritingData } from './underwriting-types';


export function getUnderwritingData(clientId: string, loanId: string): Promise<UnderwritingData> {
    return apiUtils.get(`/client/${clientId}/loan/${loanId}/underwriting-data`);
}
